import type { ProduitOrganisation } from '~/api/gen'

// Données mock pour GET /produits-organisation/{officeOid}.
export const produitsOrganisation: ProduitOrganisation[] = [
  {
    id: 1,
    code: 'LEI',
    label: 'Immonot',
    typeDiffusion: 'UNLIMITED',
  },
  {
    id: 2,
    code: 'LBC',
    label: 'Leboncoin',
    quota: 50,
    typeDiffusion: 'LIMITED',
  },
  {
    id: 3,
    code: 'SLG',
    label: 'SeLoger',
    quota: 10,
    typeDiffusion: 'LIMITED',
  },
]
